import type { VehicleImage } from '@core/Entities/Vehicle/VehicleImage.entity';
import { DEFAULT_IMG } from '@core/Services/Vehicle/Images/Images.constants';

const DEFAULT_IMG_OBJ: VehicleImage = {
  url: DEFAULT_IMG,
  isRelative: false,
};

const IMAGES_TAB_NAME = 'images';
const VIDEO_TAB_NAME = 'video';
const IMAGES_360_TAB_NAME = 'images360';

export { DEFAULT_IMG_OBJ, IMAGES_TAB_NAME, VIDEO_TAB_NAME, IMAGES_360_TAB_NAME };
